<template>
  <div class="filter-container">
    <proveedores-selector />
    <laboratorios-selector />
    <tipo-articulo-selector v-if="!genericos" />
    <categorias-selector v-if="!genericos" />
    <subfamilias-selector />
  </div>
</template>

<script>
import ProveedoresSelector from './selectoresFiltros/ProveedoresSelector.vue';
import LaboratoriosSelector from './selectoresFiltros/LaboratoriosSelector.vue';
import TipoArticuloSelector from './selectoresFiltros/TipoArticuloSelector.vue';
import CategoriasSelector from './selectoresFiltros/CategoriaSelector.vue';
import SubfamiliasSelector from './selectoresFiltros/SubfamiliasSelector.vue';

export default {
  name: 'FiltroGeneral',
  components: {
    ProveedoresSelector,
    LaboratoriosSelector,
    TipoArticuloSelector,
    CategoriasSelector,
    SubfamiliasSelector,
  },
  props: {
    genericos: {
      type: Boolean,
      required: true,
    },
  },
};
</script>

<style scoped>
.filter-container {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 20px;
  width: 100%;
}
</style>
